import React from 'react';
import CompletedItem from '../completed-item/CompletedItem';

const GroupedTasks = ({date, items}) => {
    return (
        <>
             <h3 className="group-completed-date">{date}</h3>
            {
                items.map((el, i) => (
                    <CompletedItem 
                        key={i} 
                        name={el.name} 
                        date={el.date} 
                        type={el.type}
                    />
                    )
                )
            }
        </>
    );
};

export default GroupedTasks;